import type { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/core/components/ui/badge";
import { Stack } from "@/core/components/ui/stack";
import { RUN_STATUS, RUN_STATUS_META } from "@/profitability/constants";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";
export const statusCol: ColumnDef<EnrichedProfitabilityPeriod> = {
  id: "status",
  header: "Status",
  // Not sortable: the underlying values sort alphabetically into an order
  // that means nothing next to the labels shown.
  enableSorting: false,
  meta: { size: "190px" },
  cell: ({ row }) => {
    const meta = RUN_STATUS_META[row.original.status];
    return (
      <Stack gap="xs" align="start">
        <Badge variant={meta.variant} size="sm">
          {meta.label}
        </Badge>
        {row.original.display.latestAttemptMessage && (
          <span className="text-xs text-tertiary-text">
            {row.original.display.latestAttemptMessage}
          </span>
        )}
        {row.original.status === RUN_STATUS.failed &&
          row.original.error?.message && (
            <span className="line-clamp-2 text-xs text-tertiary-text">
              {row.original.error.message}
            </span>
          )}
      </Stack>
    );
  },
};
